// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__ttM5_","spin":"Spinner_spin__lN8Yf","Circle":"Spinner_Circle__nY1zc","Path":"Spinner_Path__8C5qy"};